import { CONSENT_COOKIE_GOOGLE_ANALYTICS, CONSENT_COOKIE_KEY, CONSENT_COOKIE_NECESSARY } from "../../rutab-constants";

export const ConsentAllCookies = (setCookie) => {
    var accepted = {
        Accepted: [CONSENT_COOKIE_NECESSARY],
        AllowedServices: [CONSENT_COOKIE_GOOGLE_ANALYTICS]
    };
    setCookie(CONSENT_COOKIE_KEY, JSON.stringify(accepted), { path: '/', expires: CreateExpirationDate() })
}

export const ConsentOptionalCookies = (setCookie, optionalCookies) => {
    var accepted = {
        Accepted: [CONSENT_COOKIE_NECESSARY],
        AllowedServices: []
    };

    for (let i = 0; i < optionalCookies.length; i++) {
        const optionalCookie = optionalCookies[i];
        if (optionalCookie.accepted) {
            accepted.AllowedServices.push(optionalCookie.key);
        }
    }

    setCookie(CONSENT_COOKIE_KEY, JSON.stringify(accepted), { path: '/', expires: CreateExpirationDate() })
}

export const CookieConsentNotInitzialized = (cookies) => {
    return cookies[CONSENT_COOKIE_KEY] === '' || cookies[CONSENT_COOKIE_KEY] === undefined;
}

const CreateExpirationDate = () => {
    var result = new Date();
    result.setDate(result.getDate() + 14);
    return result;
}
